<template>
  <div>
    <h2 class="font-semibold uppercase text-gray-600">
      Add Driver
    </h2>

    <form @submit.prevent="add" class="space-y-4">
      <div class="flex -mx-2">
        <div class="w-1/2">
          <label class="block px-2">
            <span class="text-gray-700">First Name</span>
            <input
              v-model="driver.firstName"
              class="form-input mt-1 block w-full"
              placeholder="Jane"
            />
          </label>
        </div>
        <div class="w-1/2">
          <label class="block px-2">
            <span class="text-gray-700">Last Name</span>
            <input
              v-model="driver.lastName"
              class="form-input mt-1 block w-full"
              placeholder="Doe"
            />
          </label>
        </div>
      </div>
      <label class="block">
        <span class="text-gray-700">Email</span>
        <input
          v-model="driver.email"
          class="form-input mt-1 block w-full"
          type="email"
          placeholder="johndoe@gmail.com"
        />
      </label>
      <label class="block">
        <span class="text-gray-700">Contact Number</span>
        <input
          v-model="driver.phoneNumber"
          class="form-input mt-1 block w-full"
          type="text"
          placeholder="+251 912345678"
        />
      </label>
      <div>
        <photo-uploader v-model="driver.profileImage" label="Profile Picture" />
      </div>
      <label class="block">
        <span class="text-gray-700">City</span>
        <input
          v-model="driver.city"
          class="form-input mt-1 block w-full"
          type="text"
          placeholder="Addis Ababa"
        />
      </label>
      <label class="block mt-4">
        <span class="text-gray-700">Vehicle Type</span>
        <select class="form-select mt-1 block w-full">
          <option
            v-for="type in vehicleTypes"
            :value="type._id"
            :key="`vType-${type._id}`"
          >
            {{ type.name }}
          </option>
        </select>
      </label>
      <div>
        <photo-uploader
          v-model="driver.businessLicense"
          label="BusinessLicense"
        />
      </div>
      <div>
        <photo-uploader
          v-model="driver.drivingLicense"
          label="Driver's License"
        />
      </div>
      <label class="flex items-center space-x-4">
        <input
          type="checkbox"
          class="form-checkbox"
          v-model="driver.representative"
        />
        <span>Representative (Optional)</span>
      </label>
      <div v-if="driver.representative">
        <photo-uploader
          v-model="driver.representationPaper"
          label="Representation Paper"
        />
      </div>
      <button
        class="px-4 py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-700"
      >
        Add Driver
      </button>
    </form>
  </div>
</template>

<script>
import PhotoUploader from "@/components/PhotoUploader.vue";

export default {
  components: {
    PhotoUploader,
  },
  data() {
    return {
      driver: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        profileImage: "",
        city: "",
        vehicleType: "",
        businessLicense: "",
        drivingLicense: "",
        representationPaper: "",
      },
      vehicleTypes: [],
    };
  },
  created() {
    this.getVehicleTypes();
  },
  methods: {
    getVehicleTypes() {
      this.$http
        .get("vehicleTypes")
        .then(({ data }) => (this.vehicleTypes = data.data))
        .catch(err => console.log(err));
    },
    add() {
      this.$http
        .post("drivers", this.driver)
        .then(() => {
          window.flash({
            type: "success",
            body: "Driver added successfully!",
          });
          this.$router.push("/drivers");
        })
        .catch(err => {
          window.flash({
            type: "error",
            body: "Failed to add the driver!",
          });
          console.log(err);
        });
    },
  },
};
</script>
